import { render, staticRenderFns } from "./CorporateAction.vue?vue&type=template&id=f0fd28f4"
import script from "./CorporateAction.vue?vue&type=script&lang=js"
export * from "./CorporateAction.vue?vue&type=script&lang=js"
import style0 from "./CorporateAction.vue?vue&type=style&index=0&id=f0fd28f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports